import { device } from 'src/styles/breakpoints'
import { orange, white } from 'src/styles/colors'
import styled from 'styled-components'

export const Section = styled.section`
  background-color: #3f3f42;
  padding: 46px 0;

  @media ${device.tablet} {
    padding: 62.31px 0 42px 0;
  }

  @media ${device.desktopLG} {
    padding: 71.27px 0 44px 0;
  }

  @media ${device.desktopXL} {
    padding: 71.27px 0 73px 0;
  }

  h2 {
    font-family: 'Citrina', Helvetica, sans-serif;
    font-weight: 700;

    @media ${device.desktopXXL} {
      font-size: 50px;
    }
  }

  strong {
    color: ${orange.base};
  }

  .carrossel {
    .react-multi-carousel-track {
      padding-bottom: 24px;
    }

    @media ${device.desktopXL} {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .margin-card-experts {
    margin-right: 37px;

    &:last-child {
      margin-right: 0;
    }
  }
`

export const ExpertCard = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  @media ${device.desktopXL} {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  img {
    object-fit: cover;
    border-radius: 8px;
  }

  h3 {
    font-size: 22.91px;
    line-height: 27px;
    font-weight: 700;
    color: ${white};
    text-align: center;
    margin: 14px 0;
  }

  p {
    font-size: 13.09px;
    line-height: 15.5px;
    font-weight: 400;
    color: ${white};
    text-align: center;
  }
`

export const Button = styled.button`
  background-color: ${orange.base};
  color: ${white};
  padding: 10px 20px;
  border-radius: 8px;
  margin-top: 10.7px;
  width: 100%;
  min-width: 208px;
  height: 48px;
  font-size: 14px;
  font-weight: 700;

  @media ${device.tablet} {
    min-width: 218px;
    margin-top: 0;
  }
  @media ${device.desktopLG} {
    min-width: 298px;
  }
  @media ${device.desktopXL} {
    min-width: 360px;
    margin-top: 4.72px;
  }
`
